import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { StartComponent } from './start/start.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { MatExpansionModule } from '@angular/material/expansion';
import {MatToolbarModule} from '@angular/material/toolbar';

import { SwiperModule } from 'swiper/angular';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { AnimateOnScrollModule } from 'ng2-animate-on-scroll';
import { ScanQrcodeModule } from '../scan-qrcode/scan-qrcode.module';
import { SharedModule } from '../shared/shared.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import {MatDialogModule} from '@angular/material/dialog';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { WebsiteComponent } from './website.component';
import { TermsAndConditionsComponent } from './terms-and-conditions/terms-and-conditions.component';

const routes: Routes = [
  { path: '', component: WebsiteComponent, children: [
    { path: '', component: StartComponent },
    { path: 'privacy-policy', component: PrivacyPolicyComponent },
    { path: 'terms-and-conditions/:restId', component: TermsAndConditionsComponent }, // not necessary for now
    { path: 'terms-and-conditions', component: TermsAndConditionsComponent },
  ] },
  // { path: 'privacy-policy', component: PrivacyPolicyComponent }
];      


@NgModule({
  declarations: [StartComponent, PrivacyPolicyComponent, WebsiteComponent, TermsAndConditionsComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatDividerModule,
    FlexLayoutModule,
    MatCardModule,
    MatIconModule,
    MatTabsModule,
    MatExpansionModule,
    MatProgressSpinnerModule,
    SwiperModule,
    ScanQrcodeModule,
    MatDialogModule,
    MatCheckboxModule,
    MatToolbarModule,
    AnimateOnScrollModule.forRoot(),
    RouterModule.forChild(routes)
  ],
  exports: [RouterModule]
})
export class WebsiteModule { }
